'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Videos = exports.NewInterpretDialogContent = exports.SongMetaInfo = undefined;

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _redboxReact2 = require('redbox-react');

var _redboxReact3 = _interopRequireDefault(_redboxReact2);

var _react2 = require('react');

var _react3 = _interopRequireDefault(_react2);

var _reactTransformCatchErrors3 = require('react-transform-catch-errors');

var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);

var _class, _temp, _class2, _temp2, _class3, _temp3, _dec, _class4, _class5, _temp4;

var _reactRouter = require('react-router');

var _reactBootstrap = require('react-bootstrap');

var _components2 = require('components');

var _redux = require('redux');

var _ = require('..');

var _reactRedux = require('react-redux');

var _info = require('redux/modules/info');

var _docs = require('redux/modules/docs');

var _AgamaText = require('../../helpers/AgamaText');

var _utils = require('../../../api/actions/Db/utils');

var _reduxRouter = require('redux-router');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _components = {
  SongMetaInfo: {
    displayName: 'SongMetaInfo'
  },
  NewInterpretDialogContent: {
    displayName: 'NewInterpretDialogContent'
  },
  Videos: {
    displayName: 'Videos'
  },
  Song: {
    displayName: 'Song'
  }
};

var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
  filename: '/home/Devel/web/productionRc/Agama2016/src/components/Song/Song.js',
  components: _components,
  locals: [],
  imports: [_react3.default, _redboxReact3.default]
});

function _wrapComponent(id) {
  return function (Component) {
    return _reactTransformCatchErrors2(Component, id);
  };
}
// import { isSongsLoaded, loadSongs, isDocumentLoaded, loadDocument } from 'redux/modules/docs';


var converter = new _AgamaText.SongToAgamaConverter(); // staci jeden spolecnej objekt
var docTextSize = 'docTextSize';

var SongMetaInfo = exports.SongMetaInfo = _wrapComponent('SongMetaInfo')((_temp = _class = function (_Component) {
  (0, _inherits3.default)(SongMetaInfo, _Component);

  function SongMetaInfo() {
    (0, _classCallCheck3.default)(this, SongMetaInfo);
    return (0, _possibleConstructorReturn3.default)(this, (SongMetaInfo.__proto__ || (0, _getPrototypeOf2.default)(SongMetaInfo)).apply(this, arguments));
  }

  (0, _createClass3.default)(SongMetaInfo, [{
    key: 'render',
    value: function render() {
      var styles = require('./Song.scss');
      var _props = this.props,
          format = _props.format,
          value = _props.value,
          description = _props.description;

      if (!value) return null;
      var v = this.props.value;
      var itemProp = null;
      if (format === 'date') {
        var d = new Date(value);
        var tz = d.getTimezoneOffset() / -60;
        v = d.toLocaleString('en-US') + ' (GMT' + (tz > 0 ? '+' : '-') + tz + ')'; //pozor, musi fungovat na serveru i na klientovi, jinak bude jiny crc
        v = value; //zatim
        itemProp = 'dateModified';
      }
      return _react3.default.createElement(
        'div',
        { className: styles.songMetaInfo + ' noPrint' },
        _react3.default.createElement(
          'span',
          null,
          description,
          ' :'
        ),
        _react3.default.createElement(
          'span',
          { itemProp: itemProp },
          v
        )
      );
    }
  }]);
  return SongMetaInfo;
}(_react2.Component), _class.propTypes = {
  description: _react2.PropTypes.string.isRequired,
  value: _react2.PropTypes.string.isRequired,
  format: _react2.PropTypes.string
}, _temp));

var NewInterpretDialogContent = exports.NewInterpretDialogContent = _wrapComponent('NewInterpretDialogContent')((_temp2 = _class2 = function (_Component2) {
  (0, _inherits3.default)(NewInterpretDialogContent, _Component2);

  function NewInterpretDialogContent() {
    (0, _classCallCheck3.default)(this, NewInterpretDialogContent);
    return (0, _possibleConstructorReturn3.default)(this, (NewInterpretDialogContent.__proto__ || (0, _getPrototypeOf2.default)(NewInterpretDialogContent)).apply(this, arguments));
  }

  (0, _createClass3.default)(NewInterpretDialogContent, [{
    key: 'render',
    value: function render() {
      var onCreate = this.props.onCreate;

      var self = this;
      var create = function create() {
        var value = self.refs.newInterpretNameInput.value.trim();
        if (value.length === 0) return;
        if (value.toLowerCase().indexOf('ortel') > -1) {
          alert('Neonacistickou skupinu nelze založit');return;
        };
        if (value.toLowerCase().indexOf('conflict') > -1) {
          alert('Neonacistickou skupinu nelze založit');return;
        };
        onCreate(value);
      };

      //const styles = require('./Song.scss');
      return _react3.default.createElement(
        'div',
        null,
        ' ',
        _react3.default.createElement(
          'div',
          null,
          'Zadejte jm\xE9no nov\xE9ho interpreta (zp\u011Bv\xE1k nebo hudebn\xED skupina):'
        ),
        _react3.default.createElement('input', { type: 'text', ref: 'newInterpretNameInput' }),
        _react3.default.createElement(
          'button',
          { onClick: create },
          'Vytvo\u0159it'
        )
      );
    }
  }]);
  return NewInterpretDialogContent;
}(_react2.Component), _class2.propTypes = {
  onCreate: _react2.PropTypes.func.isRequired
}, _temp2));

var Videos = exports.Videos = _wrapComponent('Videos')((_temp3 = _class3 = function (_Component3) {
  (0, _inherits3.default)(Videos, _Component3);

  function Videos() {
    (0, _classCallCheck3.default)(this, Videos);
    return (0, _possibleConstructorReturn3.default)(this, (Videos.__proto__ || (0, _getPrototypeOf2.default)(Videos)).apply(this, arguments));
  }

  (0, _createClass3.default)(Videos, [{
    key: 'render',
    value: function render() {
      var styles = require('./Song.scss');
      var youtubeCodes = (0, _utils.toArray)(this.props.youtubeCodes); // eslint-disable-line no-shadow
      var children = (youtubeCodes || []).map(function (code, keyIndex) {
        return _react3.default.createElement(
          'div',
          { key: keyIndex },
          _react3.default.createElement('iframe', { src: 'https://www.youtube.com/embed/' + code, frameBorder: '0', allowFullScreen: true })
        );
      });
      return _react3.default.createElement(
        'div',
        { className: styles.videos + ' noPrint' },
        children
      );
    }
  }]);
  return Videos;
}(_react2.Component), _class3.propTypes = {
  youtubeCodes: _react2.PropTypes.oneOfType([_react2.PropTypes.arrayOf(_react2.PropTypes.string), _react2.PropTypes.string])
}, _temp3));

var Song = _wrapComponent('Song')((_dec = (0, _reactRedux.connect)(function (state) {
  return { docs: state.docs, info: state.info.data, authState: state.auth };
}, function (dispatch) {
  return (0, _redux.bindActionCreators)({ pushState: _reduxRouter.pushState, setUiProps: _info.setUiProps, createDialog: _info.createDialog, changeSongText: _docs.changeSongText, changeSongProp: _docs.changeSongProp, changeGlobalState: _docs.changeGlobalState, changeSongTextPersistent: _docs.changeSongTextPersistent, panelVisibleToSide: _info.panelVisibleToSide }, dispatch);
}), _dec(_class4 = (_temp4 = _class5 = function (_Component4) {
  (0, _inherits3.default)(Song, _Component4);

  function Song() {
    (0, _classCallCheck3.default)(this, Song);
    return (0, _possibleConstructorReturn3.default)(this, (Song.__proto__ || (0, _getPrototypeOf2.default)(Song)).apply(this, arguments));
  }

  (0, _createClass3.default)(Song, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var self = this;
      var oldSize = 0;
      var oldText = null;
      var oldKey = '';
      var checkFunc = function checkFunc() {
        var xid = self.props.xid;
        var versionId = self.props.versionId;

        var currentFontSize = self.props.info.ui[docTextSize] || 100;

        var key = (0, _utils.getCombinedKey)(xid, versionId);
        var doc = self.props.docs.documentCache[key];
        var text = (self.props.currentChord || '') + ((doc.changes || {}).text || doc.text);
        var upperScrollable = self.refs.root.parentElement.parentElement;
        var size = upperScrollable.offsetHeight * upperScrollable.offsetWidth + currentFontSize;
        if (oldText === text && oldSize === size) return;
        oldText = text;
        oldSize = size;
        console.log('song redrawing..');

        // console.log('Redrawing...');
        (0, _AgamaText.postFormat)(self.refs.root);
        if (oldKey !== key) {
          upperScrollable.scrollTop = 0;
          self.refs.textarea.scrollTop = 0;
          window.ga('send', 'pageview', location.pathname);
          console.log('pageview: ' + location.pathname);
        }
        oldKey = key;
      };
      self.__removeInterval = setInterval(checkFunc, 500);

      self.__mediaQueryList = window.matchMedia('print');

      self.__removePrintListener = function (mql) {
        if (mql.matches) {
          console.log('onbeforeprint');
          (0, _AgamaText.postFormat)(self.refs.root);
        };
      };
      self.__mediaQueryList.addListener(self.__removePrintListener);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      var self = this;
      console.log('Unmounting...');
      clearInterval(self.__removeInterval);
      self.__mediaQueryList.removeListener(self.__removePrintListener);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this5 = this;

      var _props2 = this.props,
          pushState = _props2.pushState,
          xid = _props2.xid,
          versionId = _props2.versionId,
          path = _props2.path,
          docs = _props2.docs,
          changeGlobalState = _props2.changeGlobalState,
          changeSongProp = _props2.changeSongProp,
          changeSongTextPersistent = _props2.changeSongTextPersistent,
          currentChord = _props2.currentChord,
          setUiProps = _props2.setUiProps,
          panelVisibleToSide = _props2.panelVisibleToSide,
          authState = _props2.authState,
          createDialog = _props2.createDialog; // eslint-disable-line no-shadow

      var documentCache = docs.documentCache;
      var user = authState.user;
      var ui = this.props.info.ui;
      /** je česká notace pro zobrazeni -bool*/

      var isTargetNotationCz = ui.song_notationCZ === false ? false : true;
      var isNew = xid === 'newSong';
      var isNotNew = !isNew;

      // const subItemId = this.props.params.subItemId;
      // const styles = require('./Home.scss');
      // require the logo image both from client and server
      // const logoImage = require('./logo.png');
      var combinedKey = (0, _utils.getCombinedKey)(xid, versionId);
      var document = xid ? documentCache[combinedKey] : '';
      var docId = document.id,
          previousId = document.previousId;

      var changes = document.changes || {};
      var custom = document.custom || {};
      //const interprets = isNew ? (changes.interprets == null ? document.interprets : changes.interprets).concat(['_empty']) : (changes.interprets == null ? document.interprets : changes.interprets);
      var interprets = (changes.interprets == null ? document.interprets : changes.interprets).concat(['_empty']);
      var isSaving = custom.isSaving;

      var hasUnsavedChange = (0, _keys2.default)(changes).length > 0;
      var canPublish = hasUnsavedChange && user != null;
      if (hasUnsavedChange) {
        if (isNew) {
          //const keys = Object.keys(changes);
          canPublish = changes.interprets != null && changes.text != null && changes.text.length > 10 && changes.name != null;
          canPublish = canPublish && changes.text.trim().length > 0 && changes.name.trim().length > 0;
        } else {
          if (changes.name != null && changes.name.length < 3) canPublish = false;
          if (changes.text != null && changes.text.length <= 10) canPublish = false;
        }
      }

      var styles = require('./Song.scss');
      var createPersons = function createPersons(personIds, editMode) {
        return personIds.map(function (personId) {
          return _react3.default.createElement(_components2.Person, { id: personId, songId: xid, key: personId, editMode: editMode });
        });
      };

      var versionName = versionId ? _react3.default.createElement(
        'span',
        { className: styles.versionName + ' noPrint' },
        versionId
      ) : null;

      var createSpecVersionUrl = function createSpecVersionUrl() {
        if (!previousId) {
          if (!versionId) return null;
        }

        var basePath = path.split('/').filter(function (x, i) {
          return i <= 3;
        });
        var endPath = path.split('/').filter(function (x, i) {
          return i > 3;
        });
        var specVersionUrlPart = ['specificVersion', previousId];
        var specVersionUrl = basePath.concat(specVersionUrlPart).concat(endPath).join('/');
        //  <ToolButton glyphIconName="arrow-left" linkTo={frindlyName(specVersionUrl)} nofollow inGroup inVerticalGroup={false}/>
        //  <ToolButton  linkTo={frindlyName(path)} nofollow inGroup inVerticalGroup={false}>xxxxx</ToolButton>
        var lastVersionLink = versionId ? _react3.default.createElement(
          _reactRouter.Link,
          { to: (0, _utils.frindlyName)(path) },
          'Zobrazit aktu\xE1ln\xED verzi'
        ) : null;
        var specificVersionLink = previousId ? _react3.default.createElement(
          _reactRouter.Link,
          { to: (0, _utils.frindlyName)(specVersionUrl) },
          'Zobrazit p\u0159edchoz\xED verzi'
        ) : null;
        var popis = versionId ? _react3.default.createElement(
          'div',
          { className: styles.versionDescription },
          'Pr\xE1v\u011B si prohl\xED\u017E\xEDte archivn\xED z\xE1znam (ID: ',
          versionName,
          ')'
        ) : null;
        return _react3.default.createElement(
          'div',
          { className: styles.versionBlock + ' noPrint' },
          popis,
          ' ',
          specificVersionLink,
          ' ',
          versionId && previousId ? _react3.default.createElement(
            'b',
            null,
            '\xA0\xA0\xA0|\xA0\xA0\xA0'
          ) : null,
          ' ',
          lastVersionLink,
          ' '
        );
      };

      var versionBlock = createSpecVersionUrl(previousId);
      var editDisabled = versionId ? true : false;

      // visibleSourceText slouží jen pro zobrazení zdroje (text..originál ze serveru; newText..lokální vytvořený neuložený na serveru)
      var visibleSourceText = changes.text == null ? document.text : changes.text;
      var songObj = converter.convertToAgama(visibleSourceText, { targetNotation: isTargetNotationCz ? 'CZ' : 'INT' });

      // zkusíme vzít akord z url (zkontrolujeme jej)- jinak zpracujeme text písně
      if (currentChord) {
        var currentChordT = currentChord.replace(/\is/g, '#'); // z url prijde ve tvaru Cis, Dis atp.

        var isValidChord = (0, _AgamaText.transposeChord)(currentChordT, 0, true, songObj.analysis.sourceNotation, isTargetNotationCz ? 'CZ' : 'INT') !== null;
        if (isValidChord) {
          // transponujeme model
          songObj.transposeModel(currentChordT);
        }
      }
      var html = songObj.getHtml();

      // const changeText = (ev)=>{
      //   const newTextValue = ev.target.value.substring(0, 20000);
      //   changeSongText(xid, newTextValue);
      // };
      var changeTitle = function changeTitle(ev) {
        if (editDisabled) return;
        var newName = (0, _utils.secureTextNice)(ev.target.value.substring(0, 200).replace(/(\r)/gm, '')); //.replace(/(\r\n|\n|\r)/gm,"");
        changeSongProp(xid, function (doc) {
          if (doc.name === newName) delete doc.changes.name;else doc.changes.name = newName;
        });
      };
      var changeText = function changeText(ev) {
        if (editDisabled) return;
        var newText = ev.target.value.substring(0, 20000).replace(/(\r)/gm, '');
        changeSongProp(xid, function (doc) {
          if (doc.text === newText) delete doc.changes.text;else doc.changes.text = newText;
        });
      };
      var resetChanges = function resetChanges() {
        changeSongProp(xid, function (doc) {
          delete doc.changes;
        });
      };

      // zobrazení velikosti písma
      var currentSize = (ui[docTextSize] || 100) + '%';

      var resetCursor = function resetCursor(txtElement) {
        if (txtElement.setSelectionRange) {
          txtElement.focus();
          txtElement.setSelectionRange(0, 0);
        } else if (txtElement.createTextRange) {
          var range = txtElement.createTextRange();
          range.moveStart('character', 0);
          range.select();
        }
      };

      var showSourceClick = function showSourceClick() {
        var ta = _this5.refs.textarea;
        ta.className = ta.className.replace('hidden ', '');
        setTimeout(function () {
          //ta.scrollIntoViewIfNeeded(); //todo: vyresit pomoci Collapse - jako playlisty
          //resetCursor(ta);
          setUiProps({ name: 'showSongText', value: true });
        }, 10);
      };

      var playListArea = _react3.default.createElement(_.PlaylistBtn, { xid: xid, versionId: versionId });
      var sourceBtn = ui.showSongText ? _react3.default.createElement(
        _reactBootstrap.Button,
        { bsStyle: 'primary',
          onClick: function onClick() {
            return setUiProps({ name: 'showSongText', value: false });
          } },
        'skr\xFDt editaci ',
        _react3.default.createElement(_reactBootstrap.Glyphicon, { glyph: 'triangle-top' })
      ) : _react3.default.createElement(
        _reactBootstrap.Button,
        { bsStyle: 'primary',
          onClick: showSourceClick },
        'Upravit ',
        _react3.default.createElement(_reactBootstrap.Glyphicon, { glyph: 'triangle-bottom' })
      );
      var publishTxt = isSaving ? _react3.default.createElement(
        'span',
        null,
        _react3.default.createElement(
          'span',
          { className: 'fa fa-refresh fa-spin' },
          ' '
        ),
        ' Publikuji... '
      ) : _react3.default.createElement(
        'span',
        null,
        _react3.default.createElement(_reactBootstrap.Glyphicon, { glyph: 'upload' }),
        ' Publikovat '
      );
      var missingUserInfo = user == null ? _react3.default.createElement(
        'div',
        null,
        _react3.default.createElement(_reactBootstrap.Glyphicon, { glyph: 'comment' }),
        '  Nejste p\u0159ihl\xE1\u0161en\xED - pro publikov\xE1n\xED se pros\xEDm p\u0159ihlaste. '
      ) : null;

      //const onDone = res=> {  pushState(null, '/'); alert('OK. je třeba provést refresh.');};
      //const onDone = (res) => {};
      var onDone = function onDone(url) {
        return pushState(null, url);
      };

      var saveAll = function saveAll() {
        var mode = isNew ? 'create' : 'update';
        var _msg = isNew ? _react3.default.createElement(
          'span',
          null,
          _react3.default.createElement(
            'b',
            null,
            'Opravdu chcete p\xEDse\u0148 publikovat?'
          ),
          _react3.default.createElement('br', null),
          ' '
        ) : _react3.default.createElement(
          'span',
          null,
          _react3.default.createElement(
            'b',
            null,
            'Opravdu chcete zm\u011Bny ulo\u017Eit a publikovat tak va\u0161e zm\u011Bny ?'
          ),
          _react3.default.createElement('br', null),
          ' St\xE1vaj\xEDc\xED verze p\xEDsn\u011B z\u016Fstane zachov\xE1na jako sou\u010D\xE1st historuck\xFDch z\xE1znam\u016F a lze si ji tak\xE9 kdykoli zobrazit'
        );

        createDialog({
          title: 'Potvrzení / Confirmation',
          msg: function msg() {
            return _msg;
          },
          okNoText: 'Cancel',
          okBtnText: 'Publikovat',
          onClick: function onClick(ctx) {
            changeSongTextPersistent(xid, docId, 'Song', mode, onDone);
            createDialog({ title: 'Publikuji...', msg: function msg() {
                return _react3.default.createElement(
                  'span',
                  null,
                  _react3.default.createElement(
                    'span',
                    { className: 'fa fa-refresh fa-spin' },
                    ' '
                  ),
                  ' \xA0\xA0Chvilku strpen\xED... '
                );
              }, onClick: null, onNoClick: null });
          },
          onNoClick: function onNoClick(ctx) {
            ctx.closeDialog();
          },
          ico: 'alert',
          autoClose: false

        });
      };

      var unsaved = isNotNew ? _react3.default.createElement(
        'div',
        null,
        missingUserInfo,
        _react3.default.createElement(
          'div',
          { style: { transition: 'all ease 1000ms', opacity: hasUnsavedChange ? 1 : 0 } },
          _react3.default.createElement(_reactBootstrap.Glyphicon, { glyph: 'comment' }),
          '  Neulo\u017Eeno trvale!!!  Pouze  zm\u011Bna  prohl\xED\u017Ee\u010Di. Pro trval\xE9 ulo\u017Een\xED publikujte. '
        ),
        _react3.default.createElement(
          _reactBootstrap.Button,
          { bsStyle: 'primary', disabled: !hasUnsavedChange || isSaving, onClick: resetChanges },
          _react3.default.createElement(_reactBootstrap.Glyphicon, { glyph: 'remove-circle' }),
          ' Zahodit zm\u011Bny'
        ),
        _react3.default.createElement(
          _reactBootstrap.Button,
          { bsStyle: 'primary', disabled: !canPublish || isSaving, onClick: saveAll },
          publishTxt
        )
      ) : null;
      var unsavedNew = isNew ? _react3.default.createElement(
        'div',
        null,
        missingUserInfo,
        _react3.default.createElement(
          _reactBootstrap.Button,
          { bsStyle: 'primary', onClick: function onClick() {
              return pushState(null, '/');
            } },
          'Cancel'
        ),
        _react3.default.createElement(
          _reactBootstrap.Button,
          { bsStyle: 'primary', disabled: !hasUnsavedChange || isSaving, onClick: resetChanges },
          _react3.default.createElement(_reactBootstrap.Glyphicon, { glyph: 'remove-circle' }),
          ' Zahodit zm\u011Bny'
        ),
        _react3.default.createElement(
          _reactBootstrap.Button,
          { bsStyle: 'primary', disabled: !canPublish || isSaving, onClick: saveAll },
          publishTxt
        )
      ) : null;
      //const videos = document.videos ? <Videos youtubeCodes={document.videos}/> : null;
      var videos = songObj.model.videos ? _react3.default.createElement(Videos, { youtubeCodes: songObj.model.videos }) : null;
      var onClick = function onClick() {
        panelVisibleToSide({ name: 'navigation', childPanelName: 'subNavigation', mySide: 'left' });
      };
      var popisEditace = editDisabled ? _react3.default.createElement(
        'small',
        null,
        ' Toto je archivn\xED z\xE1znam a proto jej nelze upravovat'
      ) : '';

      var addNewInterpret = function addNewInterpret(newInterpretName) {
        //const newText = ev.target.value.trim().substring(0, 20000).replace(/(\r)/gm,'');
        var newOne = { id: new Date() / -1 + '', clientOnly: true, name: (0, _utils.secureTextNice)(newInterpretName), used: false };
        changeGlobalState(function (state) {
          return (0, _extends3.default)({}, state, { data: (0, _extends3.default)({}, state.data, { docs: (0, _extends3.default)({}, state.data.docs, { persons: [newOne].concat((0, _toConsumableArray3.default)(state.data.docs.persons)) }) }) });
        });
        changeSongProp(xid, function (doc) {
          //doc.changes.newInterprets = doc.changes.newInterprets ?  [...doc.changes.newInterprets,newOne.id] : [newOne.id];
          doc.changes.interprets = doc.changes.interprets ? [].concat((0, _toConsumableArray3.default)(doc.changes.interprets), [newOne.id]) : [].concat((0, _toConsumableArray3.default)(doc.interprets), [newOne.id]);
          //doc.changes.interprets =   [...doc.changes.interprets,newOne.id] ;

        });
      };

      //const fakeNewPerson = isNotNew ? <Person songId={xid} id='_empty' editMode /> : null;
      var createNewInterpret = function createNewInterpret() {
        createDialog({
          title: 'Vytvoření nového interpreta',
          msg: function msg(dialogContext) {
            return _react3.default.createElement(NewInterpretDialogContent, { onCreate: function onCreate(name) {
                addNewInterpret(name);dialogContext.closeDialog();
              } });
          },
          onNoClick: function onNoClick() {}, okNoText: 'Cancel'
        });
      };

      return _react3.default.createElement(
        'div',
        { className: styles.songTextRoot, ref: 'root', itemProp: 'mainEntity', itemScope: true, itemType: 'http://schema.org/MusicComposition' },
        _react3.default.createElement(
          'h1',
          { className: 'font-effect-3d-float', onClick: onClick },
          hasUnsavedChange && isNotNew ? _react3.default.createElement(
            'sup',
            { title: 'not saved', className: 'noPrint' },
            ' * '
          ) : null,
          _react3.default.createElement(
            'span',
            { itemProp: 'name' },
            changes.name || document.name,
            ' ',
            versionName
          )
        ),
        _react3.default.createElement(
          'h2',
          { className: styles.persons },
          createPersons(interprets, false),
          ' '
        ),
        _react3.default.createElement(
          'div',
          { itemProp: 'lyrics', itemScope: true, itemType: 'http://schema.org/CreativeWork' },
          _react3.default.createElement('div', { itemProp: 'text', dangerouslySetInnerHTML: { __html: html }, style: { fontSize: currentSize }, className: 'songText', ref: 'songText' })
        ),
        _react3.default.createElement(
          'div',
          { className: styles.songEdit + ' noPrint' },
          isNotNew ? playListArea : null,
          ' ',
          isNotNew ? sourceBtn : null,
          _react3.default.createElement(
            'div',
            { className: (ui.showSongText || isNew ? ' ' : 'hidden ') + styles.editForm + ' ' + (hasUnsavedChange ? styles.unsaved : '') },
            _react3.default.createElement(
              'div',
              null,
              _react3.default.createElement(
                'span',
                null,
                'N\xE1zev p\xEDsn\u011B: '
              ),
              _react3.default.createElement('input', { value: changes.name == null ? document.name : changes.name, onChange: changeTitle, className: editDisabled ? styles.readonly : '' }),
              _react3.default.createElement(
                'div',
                { className: styles.personsEdit },
                'Interpret(i): ',
                _react3.default.createElement('br', null),
                _react3.default.createElement(
                  'div',
                  null,
                  _react3.default.createElement(
                    'i',
                    null,
                    'Vyberte minim\xE1ln\u011B jednoho interpreta (zp\u011Bv\xE1ka, skupinu). Pokud dosud v seznamu nen\xED, vytvo\u0159te jej pomoc\xED tla\u010D\xEDtka.'
                  )
                ),
                createPersons(interprets, true),
                ' \xA0\xA0\xA0',
                _react3.default.createElement(
                  'button',
                  { onClick: createNewInterpret },
                  'Vytvo\u0159it interpreta'
                )
              ),
              popisEditace
            ),
            _react3.default.createElement(
              'div',
              { itemProp: 'text' },
              _react3.default.createElement('textarea', { ref: 'textarea', className: (editDisabled ? styles.readonly : '') + ' scrollable', value: visibleSourceText, onChange: changeText })
            ),
            unsavedNew,
            ' ',
            unsaved
          )
        ),
        videos,
        _react3.default.createElement(
          'div',
          { className: styles.songMetaInfos },
          _react3.default.createElement(SongMetaInfo, { description: 'Datum vytvo\u0159en\xED', value: document.created, format: 'date' }),
          _react3.default.createElement(SongMetaInfo, { description: 'Datum posledn\xED zm\u011Bny', value: document.updated, format: 'date' })
        ),
        versionBlock
      );
    }
  }]);
  return Song;
}(_react2.Component), _class5.propTypes = {
  docs: _react2.PropTypes.object,
  info: _react2.PropTypes.object,
  xid: _react2.PropTypes.string.isRequired,
  versionId: _react2.PropTypes.string,
  authState: _react2.PropTypes.object,
  path: _react2.PropTypes.string.isRequired,
  changeSongText: _react2.PropTypes.func.isRequired,
  changeSongProp: _react2.PropTypes.func.isRequired,
  changeGlobalState: _react2.PropTypes.func.isRequired,
  changeSongTextPersistent: _react2.PropTypes.func.isRequired,
  currentChord: _react2.PropTypes.string,
  setUiProps: _react2.PropTypes.func.isRequired,
  panelVisibleToSide: _react2.PropTypes.func.isRequired,
  pushState: _react2.PropTypes.func.isRequired,
  createDialog: _react2.PropTypes.func.isRequired
}, _temp4)) || _class4));

exports.default = Song;


//////////////////
// WEBPACK FOOTER
// ./src/components/Song/Song.js
// module id = 1193
// module chunks = 0